<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>栏目管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input
            v-model="query.key"
            placeholder="请输入关键词"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button
            type="success"
            @click="
              dialogVisible = true;
              form = { isEnable: true };
            "
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>栏目列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="栏目名称"
            align="center"
            min-width="20%"
          ></el-table-column>
          <el-table-column
            prop="urlName"
            label="URL伪静态"
            align="center"
            min-width="15%"
          ></el-table-column>
          <el-table-column
            prop="seq"
            label="排序字段"
            align="center"
            min-width="10%"
            sortable
          ></el-table-column>
          <el-table-column
            label="是否隐藏"
            prop="isHidden"
            align="center"
            min-width="10%"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isHidden" type="success">是</el-tag>
              <el-tag v-else type="primary">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            min-width="15%"
            sortable
          ></el-table-column>
          <el-table-column
            prop="creater.realName"
            label="创建人"
            align="center"
            min-width="15%"
          ></el-table-column>

          <el-table-column label="操作" align="center" min-width="15%">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑栏目信息' : '添加栏目信息'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="栏目名称"
          prop="name"
          :rules="[{ required: true, message: '请输入栏目名称' }]"
        >
          <el-input
            v-model="form.name"
            placeholder="请输入栏目名称"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="URL伪静态" prop="urlName">
          <el-input
            v-model="form.urlName"
            placeholder="比如“联系我们”：contact"
            maxlength="30"
            show-word-limit
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item
          label="SEO标题"
          prop="seoTitle"
          :rules="[{ required: true, message: '请输入SEO标题' }]"
        >
          <el-input
            v-model="form.seoTitle"
            placeholder="请输入SEO标题"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          label="SEO关键词"
          prop="seoKeywords"
          :rules="[{ required: true, message: '请输入SEO关键词' }]"
        >
          <el-input
            v-model="form.seoKeywords"
            placeholder="请输入SEO关键词"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          label="SEO描述"
          prop="seoDescription"
          :rules="[{ required: true, message: '请输入SEO描述' }]"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="form.seoDescription"
            placeholder="请输入SEO描述"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          label="排序数字"
          prop="seq"
          :rules="[
            { required: true, message: '不能为空' },
            { type: 'number', message: '请填写数字' },
          ]"
        >
          <el-input
            v-model.number="form.seq"
            placeholder="请输入排序数字"
          ></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="是否隐藏">
              <el-switch v-model="form.isHidden"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="(dialogVisible = false), resetForm('form')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import "../../../public/lib/cover/Cover3.0.min.css";
import "../../../public/lib/cover/Cover3.0.min.js";
export default {
  data() {
    return {
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 30,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      domain: url.getDomain(),
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getColumn("GetList");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getColumn("Save");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.resetForm("form");
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //窗口关闭事件
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("form");
          done();
        })
        .catch((_) => {});
    },
    //重置表单/重置校验
    resetForm(formName) {
      //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$refs[formName].resetFields(); //prop：在使用 validate、resetFields 方法的情况下，该属性是必填的
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
